/* eslint-disable no-unused-vars */
export enum SuitabilityField {
  IS_BROKER_DEALER = 'isBrokerDealer',
  BROKER_DEALER_EMPLOYER = 'brokerDealerEmployer',
  IS_DIRECTOR_POLICY_MAKER = 'isDirectorPolicyMakerOfCompany',
  directorPolicyMakerOfCompany = 'directorPolicyMakerOfCompany',
  TAX_FILING_STATUS = 'taxFilingStatus',
  INVESTMENT_OBJECTIVE = 'investmentObjective',
  INVESTMENT_EXPERIENCE = 'investmentExperience',
}
